import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from './page/page.component';
import { FormsModule } from '@angular/forms';
import { Route, RouterModule } from '@angular/router';
import { BannerComponent } from './components/banner/banner.component';
import { FeaturesComponent } from './components/features/features.component';
import { ImageComparisonComponent } from './components/image-comparison/image-comparison.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from '../shared/shared.module';


const routes:Route[] =[
  { path: "", component: PageComponent },
  { path: "v1", loadChildren: () => import("../cod-v1/cod-v1.module").then(m => m.CodV1Module) },
] 


@NgModule({
  declarations: [
    PageComponent,
    BannerComponent,
    FeaturesComponent,
    ImageComparisonComponent,
    // PartnersComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    SlickCarouselModule,
    SharedModule,
  ],
 
})
export class CODModule { }
